module.exports = __webpack_public_path__ + "static/img/coupon_four.bed27e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon_four.png
// module id = dXAv
// module chunks = 0